<div tabindex="-1" role="dialog" class="modal">
  <!-- <div class="modal-header">
    <h5 class="modal-title">Modal title</h5>
  </div> -->
  <div class="modal-body">
    <p>
      The browser or device you are using is not supported by OnBoard. It is recommended that you
      exit and run OnBoard on a supported device and/or in a supported browser. If you continue, you
      may incur an error.
    </p>
    <p>Supported browsers include the latest versions of:</p>
    <ul>
      <li>Google Chrome</li>
      <li>Firefox</li>
      <li>Edge (Chromium)</li>
      <li>Safari</li>
    </ul>
    <p>
      OnBoard does not support mobile devices at this time. Please visit the
      <a style="text-decoration: none" href="http://www.wcb.ny.gov/onboard/system-requirements.jsp">
        System Requirements
      </a>
      page for further information regarding supported browsers and links to update/download
      supported browsers.
    </p>

    <div class="container">
      <div class="row">
        <div class="col text-center">
          <input
            type="button"
            class="mr-2 btn btn-primary modal-button"
            value="Continue"
            (click)="modalRef.close()"
          />
          <input
            type="button"
            class="btn btn-primary modal-button"
            value="Logout"
            [routerLink]="['/logout']"
            [queryParams]="{ doLogout: true, force: true }"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer"></div>
</div>
